import React from 'react';

import { View, StyleSheet } from 'react-native';

import {
  OPComponent,
  Container,
  FormInput,
  I18n,
  NextButton,
  Navigation,
  Utils,
  NavBar,
} from '../components';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../actions/statusTypes';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { createBroadcast, resetState } from './actions';
import { getCurrentEmployer } from '../../selectors/employers';
import { BROADCAST_MESSAGING } from '../../constants/permissions';
import { currentEmployerPermissions } from '../../helpers/permissions';

import { resetState as resetCalendarState } from '../calendar/actions';

class Broadcast extends OPComponent {
  static navigatorButtons = {
    rightButtons: [
      {
        text: I18n.c1('messaging.send'),
        id: 'save',
      },
    ],
    leftButtons: [NavBar.buttons.cancel],
  };

  constructor(props) {
    super(props);

    this.state = {
      message: null,
    };
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (this.props.status === REQUESTING) return;

    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  handleChangeText(stateAttrName, text) {
    this.setState(
      {
        [stateAttrName]: text,
      },
      this.props.onInputsChanged
    );
  }

  onSave = () => {
    if (!this.props.canSendBroadcast) return;

    const employerId = this.props.currentEmployer.employerId;
    const caseIds = this.props.selectedCases;
    const message = this.state.message;

    this.props.actions.createBroadcast(employerId, caseIds, message);
  };

  componentDidMount() {
    Utils.trackScreen('Messaging', 'Broadcast');
    Navigation.registerForButtonEvents(this);
  }
  componentWillUnmount() {
    Navigation.unRegisterForButtonEvents(this);
    this.props.actions.resetState();
    this.props.actions.resetCalendarState();
  }

  componentDidUpdate(prevProps) {
    if (this.props.status === SUCCESS && prevProps.status !== SUCCESS) {
      Navigation.dismissModal(this.props.componentId);
    }
  }

  // needed for web SelectSplitScreen embedding
  validateForm = () => {
    return !!this.state.message;
  };

  render() {
    const props = this.props;
    if (!props.canSendBroadcast) return null;

    return (
      <Container
        renderActivityOverlay={this.props.status === REQUESTING}
        errorMessage={this.props.errorMessage?.message}
      >
        <View style={[THEME.inputsContainer, { flex: 1 }]}>
          <FormInput
            value={this.state.message}
            label={I18n.ac('messaging.broadcast')}
            inputStyle={styles.inputStyle}
            required={true}
            returnKeyType="default"
            autoCapitalize="sentences"
            multiline={true}
            numberOfLines={3}
            tipText={I18n.t('messaging.broadcastTip')}
            onChangeText={(text) => {
              this.handleChangeText('message', text);
            }}
          />
        </View>
        {!this.props.inSplitScreen && (
          <View style={styles.bottomContainer}>
            <NextButton
              onPress={this.onSave}
              disabled={!this.state.message}
              label={I18n.t('messaging.sendBroadcast')}
            />
          </View>
        )}
      </Container>
    );
  }
}

const styles = StyleSheet.create({
  bottomContainer: {
    padding: 25,
    paddingBottom: 45,
    justifyContent: 'flex-end',
    borderColor: '#e4e4e4',
    borderTopWidth: 1,
  },
  inputStyle: {
    height: 120,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.messaging.status,
    errorMessage: state.screens.messaging.errorMessage,
    selectedCases: state.screens.calendar.selectedCases,
    currentEmployer: getCurrentEmployer(state),
    canSendBroadcast: currentEmployerPermissions(BROADCAST_MESSAGING).canEdit,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        createBroadcast,
        resetState,
        resetCalendarState,
      },
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true } // web needs the ref forwaded
)(Broadcast);
